var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"element"},[_c('h4',{attrs:{"data-accordion-element-trigger":""}},[_vm._t("trigger")],2),_c('div',{staticClass:"content",attrs:{"data-accordion-element-content":""}},[_c('p',[_vm._t("content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }